import { BrowserRouter, Route, Switch, useLocation } from "react-router-dom";
import { createContext, useEffect, useRef, useState } from "react";
import { Provider } from "react-redux";
import store from "./Services/Redux/store";
import { DataProvider } from "./Services/Context-Api/Context";
import { PrimeReactProvider } from "primereact/api";
import { LoaderProvider } from "./Services/Loader_Provider_Service/LoadingContext";
import TosterService from "./Services/Toster-Service/TosterService";
import Preloader from "./Shared/Sidebar/Preloader";
import AppRoutes from "./Routes/AppRoutes";
import ErrorBoundary from "./Services/ErrorBoundary";
import useDisableDevTools from "./Services/BrowserPermissons/useDisableDevTools";

export const TostMsg = createContext(null);
export const Loader = createContext(null);

const App = () => {
  useDisableDevTools();
  const toster = useRef(null);

  return (
    <ErrorBoundary>
      <Provider store={store}>
        <DataProvider>
          <PrimeReactProvider>
            <TostMsg.Provider value={toster}>
              <LoaderProvider>
                <AppRoutes toster={toster} />
              </LoaderProvider>
            </TostMsg.Provider>
            <TosterService ref={toster} />
          </PrimeReactProvider>
        </DataProvider>
      </Provider>
    </ErrorBoundary>
  );
};

export default App;
